import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
export function useSaveUpdateButton() {
    const { onSave, persistedToBackend: markdownPersistedToBackend, exceededCharacterLimit, captureButtonClick, inCallOrPostCall, readOnlyYn, } = useEditorStateContext();
    const textToDisplay = markdownPersistedToBackend ? 'Update' : 'Save';
    const handleSave = async () => {
        await onSave();
        typeof captureButtonClick === 'function' &&
            captureButtonClick(`${inCallOrPostCall}-notes-${textToDisplay.toLowerCase()}-button`);
    };
    return {
        onClick: handleSave,
        textToDisplay,
        disabled: exceededCharacterLimit || readOnlyYn,
    };
}
//# sourceMappingURL=use_save_update_button.js.map